import React from "react";
import Alert from "react-bootstrap/Alert";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash.get";
import domScrollTo from "../utils/domScrollTo";
import CommonHeader from "../containers/CommonHeader";
import CartView from "../containers/CartView";
import CouponSelection from "../containers/CouponSelection";
import DeliverySelection from "../containers/DeliverySelection";
import PaymentSelection from "../containers/PaymentSelection";
import CheckoutForm from "../containers/CheckoutForm";
import InLocoForm from "../containers/InLocoForm";
import FidelityBox from "../components/FidelityBox";
import OrderScheduler from "../containers/OrderScheduler";
import CartUpsell from "../containers/CartUpsell";
import CheckoutSection from "../components/CheckoutSection";
import useGoTo from "../hooks/useGoTo";
import { AddIcon } from "../components/icons";
import SelfCheckoutPOS from "../containers/Selfcheckout/SelfCheckoutPOS";
import SelfCheckoutQRCode from "../containers/Selfcheckout/SelfCheckoutQRCode";
import SelfCheckoutTotem from "../containers/Selfcheckout/SelfCheckoutTotem";
import SelfCheckoutTable from "../containers/Selfcheckout/SelfCheckoutTable";
import CartUpsellTotem from "../containers/Selfcheckout/CartUpsellTotem";
import { MODE } from "../utils/selfcheckoutMode";
import { selectLayout } from "../ducks/shopSelectors";
import { trackViewCart } from "../ducks/tracking";

// As etapas finais de cada submodo de autoatendimento.
const SELFCHECKOUT_STEPS = {
  [MODE.POS]: SelfCheckoutPOS,
  [MODE.QRCODE]: SelfCheckoutQRCode,
  [MODE.TABLE]: SelfCheckoutTable,
  [MODE.TOTEM]: SelfCheckoutTotem,
};

function CheckoutSteps() {
  const { toGo, toDelivery } = useSelector((state) => state.checkout);
  const { mode, isInLoco, isOrderSchedulingEnabled } = useSelector(
    (state) => state.shop,
  );
  const showAll = toGo || toDelivery;

  const SelfCheckoutSteps = SELFCHECKOUT_STEPS[mode];
  if (SelfCheckoutSteps) {
    return <SelfCheckoutSteps />;
  }

  if (isInLoco) {
    return (
      <>
        <CheckoutSection title="Como vai ser?">
          <InLocoForm />
        </CheckoutSection>
        <CheckoutForm />
      </>
    );
  }

  return (
    <>
      <FidelityBox className="checkout-fidelity" />
      <CheckoutSection title="Como você quer receber?">
        <DeliverySelection />
      </CheckoutSection>
      {showAll && (
        <>
          {isOrderSchedulingEnabled && (
            <CheckoutSection title="Quando">
              <OrderScheduler />
            </CheckoutSection>
          )}
          <CheckoutSection title="Pagamento">
            <PaymentSelection />
            <CouponSelection />
          </CheckoutSection>
          <CheckoutForm />
        </>
      )}
    </>
  );
}

export default function CheckoutScreen() {
  const dispatch = useDispatch();
  const layout = useSelector(selectLayout);

  React.useEffect(() => {
    domScrollTo(0, "auto");
    dispatch(trackViewCart());
  }, [dispatch]);

  // Totem, tablet e POS: a sacola em cartões, o "Peça também" (não no POS) e
  // o rodapé fixo do QuestionCheckout.
  if (layout.checkout === "totem") {
    return (
      <div className="totem-checkout-page">
        <CommonHeader text="Sacola" />
        <CheckoutErrorAlert />
        <CartView />
        {layout.upsell && <CartUpsellTotem />}
        <CheckoutSteps />
      </div>
    );
  }

  return (
    <div className="checkout-page">
      <CommonHeader text="Sacola" />
      <CheckoutErrorAlert />
      <CheckoutSection title="Itens" action={<AddMoreItemsLink />}>
        <CartView />
      </CheckoutSection>
      {layout.upsell && <CartUpsell />}
      <CheckoutSteps />
    </div>
  );
}

function AddMoreItemsLink() {
  const goTo = useGoTo();
  return (
    <button type="button" className="link-button" onClick={() => goTo("/")}>
      <AddIcon fontSize="small" />
      Adicionar itens
    </button>
  );
}

function CheckoutErrorAlert() {
  const submitError = useSelector((state) => state.checkout.submitError);
  if (!get(submitError, "details.status")) {
    return null;
  }

  return (
    <Alert className="m-3" variant={"danger"}>
      {submitError.message}
    </Alert>
  );
}
